export type FileData = {
  byte_size: number
  content_type: string
  created_at: string
  filename: string
  size: string
  thumbnail: string
  url: string
}

export type LightboxContextType = (() => void) | undefined

export const MEDIA_TYPES = ['image', 'video']
